exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__SearchNotFound__root,\n.DS__SearchNotFound__image {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__SearchNotFound__root {\n  display: flex;\n  flex-direction: column;\n  padding: 0 24px;\n}\n\n  @media (max-width: 767px) {.DS__SearchNotFound__root {\n    align-items: center\n}\n  }\n\n@media (max-width: 767px) {\n\n.DS__SearchNotFound__subtitle {\n    margin-top: 5px\n}\n  }\n\n.DS__SearchNotFound__image {\n  margin-top: 22px;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__SearchNotFound__root",
	"image": "DS__SearchNotFound__image",
	"subtitle": "DS__SearchNotFound__subtitle"
};